<nz-page-header
  nzBackIcon
  [nzTitle]="idForUpdate ? 'Update Dashboard Config' : 'Dashboard Config'"
></nz-page-header>

<nz-card>
  <!-- ================= FEATURE CATEGORIES ================= -->
  <nz-card nzType="inner" nzTitle="Feature Categories">
    <div [formGroup]="featureCategoryForm">
      <div nz-row [nzGutter]="16">
        <!-- AVAILABLE CATEGORIES -->
        <div nz-col nzMd="12" nzSm="24">
          <nz-card nzSize="small">
            <div class="card-header">
              <h4>Available Categories ({{ filterExamCategory.length }})</h4>
              <button
                nz-button
                nzType="primary"
                nzSize="small"
                (click)="addCategories()"
              >
                Add Selected
              </button>
            </div>

            <div class="list-body">
              <nz-list nzSize="small">
                <nz-list-item *ngFor="let item of filterExamCategory">
                  <div class="item-row">
                    <label
                      nz-checkbox
                      [(ngModel)]="item.isChecked"
                      [ngModelOptions]="{ standalone: true }"
                    ></label>
                    <span class="item-text">{{ item.categoryName }}</span>
                  </div>
                </nz-list-item>
              </nz-list>

              <div class="loader" *ngIf="loading">
                <nz-spin nzSimple></nz-spin>
              </div>
            </div>

            <button
              nz-button
              nzBlock
              nzType="default"
              [disabled]="limit"
              (click)="examCategoryPagination()"
            >
              {{ limit ? "No More Categories" : "Load More Categories" }}
            </button>
          </nz-card>
        </div>

        <!-- SELECTED CATEGORIES -->
        <div nz-col nzMd="12" nzSm="24">
          <nz-card nzSize="small">
            <div class="card-header">
              <h4>
                Selected Categories ({{ newSelectedExamCategories.length }})
              </h4>
              <button
                nz-button
                nzDanger
                nzSize="small"
                (click)="removeCategories()"
              >
                Remove Selected
              </button>
            </div>

            <div
              class="list-body drag-area"
              cdkDropList
              (cdkDropListDropped)="dropCategory($event)"
            >
              <div
                class="drag-item item-row"
                *ngFor="let item of newSelectedExamCategories; index as i"
                cdkDrag
              >
                <label
                  nz-checkbox
                  [(ngModel)]="item.isChecked"
                  [ngModelOptions]="{ standalone: true }"
                ></label>

                <span class="item-text">
                  {{ i + 1 }}. {{ item.categoryName }}
                </span>
              </div>
            </div>
          </nz-card>
        </div>
      </div>

      <div class="action-bar">
        <button
          nz-button
          nzType="primary"
          [nzLoading]="buttonLoading"
          (click)="submitFeatureCategories()"
        >
          Save Categories
        </button>
      </div>
    </div>
  </nz-card>

  <nz-divider></nz-divider>

  <!-- ================= FEATURE TEST SERIES ================= -->
  <nz-card nzType="inner" nzTitle="Feature Test Series">
    <div [formGroup]="featureTestSeriesForm">
      <div nz-row [nzGutter]="16">
        <!-- AVAILABLE TEST SERIES -->
        <div nz-col nzMd="12" nzSm="24">
          <nz-card nzSize="small">
            <div class="card-header">
              <h4>Available Test Series ({{ filterTestSeries.length }})</h4>
              <div
                nz-col
                nzLg="8"
                nzMd="8"
                nzSm="24"
                nzXs="24"
                class="ml3 width-100"
              >
                <nz-input-group [nzSuffix]="suffixIconSearch">
                  <input
                    type="text"
                    nz-input
                    placeholder="Search by Test Series name"
                    ngModel
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="searchTestSeries($event)"
                  />
                </nz-input-group>
                <ng-template #suffixIconSearch>
                  <i nz-icon nzType="search"></i>
                </ng-template>
              </div>
              <button
                nz-button
                nzType="primary"
                nzSize="small"
                (click)="addTestSeries()"
              >
                Add Selected
              </button>
            </div>

            <div class="list-body">
              <nz-list nzSize="small">
                <nz-list-item *ngFor="let item of filterTestSeries">
                  <div class="item-row">
                    <label
                      nz-checkbox
                      [(ngModel)]="item.isChecked"
                      [ngModelOptions]="{ standalone: true }"
                    ></label>
                    <span class="item-text">{{ item.name }}</span>
                  </div>
                </nz-list-item>
              </nz-list>

              <div class="loader" *ngIf="testSeriesLoading">
                <nz-spin nzSimple></nz-spin>
              </div>
            </div>

            <button
              nz-button
              nzBlock
              nzType="default"
              [disabled]="testSeriesLimit"
              (click)="testSeriesPagination()"
            >
              {{
                testSeriesLimit
                  ? "No More Test Series"
                  : "Load More Test Series"
              }}
            </button>
          </nz-card>
        </div>

        <!-- SELECTED TEST SERIES -->
        <div nz-col nzMd="12" nzSm="24">
          <nz-card nzSize="small">
            <div class="card-header">
              <h4>Selected Test Series ({{ newSelectedTestSeries.length }})</h4>
              <button
                nz-button
                nzDanger
                nzSize="small"
                (click)="removeTestSeries()"
              >
                Remove Selected
              </button>
            </div>

            <div
              class="list-body drag-area"
              cdkDropList
              (cdkDropListDropped)="dropTestSeries($event)"
            >
              <div
                class="drag-item item-row"
                *ngFor="let item of newSelectedTestSeries; index as i"
                cdkDrag
              >
                <label
                  nz-checkbox
                  [(ngModel)]="item.isChecked"
                  [ngModelOptions]="{ standalone: true }"
                ></label>

                <span class="item-text"> {{ i + 1 }}. {{ item.name }} </span>
              </div>
            </div>
          </nz-card>
        </div>
      </div>

      <div class="action-bar">
        <button
          nz-button
          nzType="primary"
          [nzLoading]="buttonLoading"
          (click)="submitFeatureTestSeries()"
        >
          Save Test Series
        </button>
      </div>
    </div>
  </nz-card>
</nz-card>
